import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/Button';
import { cartSummaryStyles } from './CartSummary.styles';

export type CartSummaryTotal = {
  label: string;
  amount: string;
};

export type CartSummaryProps = {
  title: string;
  itemsLabel: string;
  itemCount: number;
  totals: CartSummaryTotal[];
  checkoutLabel: string;
  onCheckout: () => void;
  checkoutDisabled?: boolean;
  checkoutLoading?: boolean;
  footer?: ReactNode;
  className?: string;
};

export function CartSummary({
  title,
  itemsLabel,
  itemCount,
  totals,
  checkoutLabel,
  onCheckout,
  checkoutDisabled = false,
  checkoutLoading = false,
  footer,
  className,
}: CartSummaryProps): JSX.Element {
  return (
    <div className={cn(cartSummaryStyles.root, className)}>
      <h2 className={cartSummaryStyles.title}>{title}</h2>
      <div className={cartSummaryStyles.rows}>
        <div className={cartSummaryStyles.row}>
          <span>{itemsLabel}</span>
          <span>{itemCount}</span>
        </div>
        <div className={cartSummaryStyles.totals}>
          {totals.length === 0 ? (
            <div className={cartSummaryStyles.totalRow}>
              <span>—</span>
              <span>—</span>
            </div>
          ) : (
            totals.map((row) => (
              <div key={row.label} className={cartSummaryStyles.totalRow}>
                <span>{row.label}</span>
                <span>{row.amount}</span>
              </div>
            ))
          )}
        </div>
      </div>
      <Button
        type="button"
        fullWidth
        size="lg"
        onClick={onCheckout}
        disabled={checkoutDisabled}
        loading={checkoutLoading}
      >
        {checkoutLabel}
      </Button>
      {footer}
    </div>
  );
}
